<div class="body">
    <ngb-toast *ngIf="toastConfig" [autohide]="true" [delay]="3000" (hidden)="toastConfig = undefined"
        [ngClass]="toastConfig.class" style="position: absolute;">
        <container-element [ngSwitch]="toastConfig.class">
            <img *ngSwitchCase="'success'" src="assets/icone_varie/ok.svg" style="width: 20px; margin-right: 5px;">
            <img *ngSwitchCase="'warning'" src="assets/icone_varie/danger.svg" style="width: 20px; margin-right: 5px;">
            <img *ngSwitchCase="'error'" src="assets/icone_varie/error.svg" style="width: 20px; margin-right: 5px;">
        </container-element>
        {{toastConfig.title}}
    </ngb-toast>
    <div class="logo">
        <img src="assets/optima_logo.png" style= "width:500px; height: auto; margin-bottom: 20px;">
    </div>    
    <div class="loginCard">
        
        <div class="recoveryPsw">
            <h3 class="roboTitle title">{{ 'login.title' | translate }}</h3>
            <img style="cursor: pointer;" src="assets/icone_varie/info-circle.svg" title="{{ 'login.browser' | translate }}">
        </div>
        
        <div class="form-group">
            <label class="roboSubTitle" for="usr">Username</label>
            <input type="text" class="form-control" id="usr" placeholder="Username" (keydown.enter)="login()" [(ngModel)]="username">
        </div>
        <div class="form-group">
            <label class="roboSubTitle" for="password-field">Password</label>
            <input [type]="passwordFieldType" id="password-field" class="form-control" (keydown.enter)="login()" placeholder="Password" [(ngModel)]="password">
            <span toggle="#password-field" class="bi field-icon toggle-password" (click)="changeVisibility()"
            [ngClass]="{'bi-eye-slash-fill' : hidePw, 'bi-eye-fill' : !hidePw}"></span>
        </div>

        <button type="button" class="btn btn-primary btnLogin" title="{{ 'login.browser' | translate }}" (click)='login()'>Accedi</button>
        <button type="button" class="btn btn-secondary btnRegister" title="Registrati" (click)='registrazione()'>Registrati</button>
        <div class="recoveryPsw" style="cursor: pointer;" (click)="router.navigate(['recover'])">
            <p class="roboMenu">Hai dimenticato la password?</p>
        </div>

        <div class="logo">
            <img src="assets/logo.png">
        </div>

    </div>
    
</div>

<router-outlet></router-outlet>